import 'prismjs/themes/prism.css';
import 'prismjs';
import 'prismjs/components/prism-bash.min';
import 'prismjs/components/prism-clike.min';
import 'prismjs/components/prism-c.min';
import 'prismjs/components/prism-cpp.min';
import 'prismjs/components/prism-java.min';
import 'prismjs/components/prism-javascript.min';
import 'prismjs/components/prism-julia.min';
import 'prismjs/components/prism-perl.min';
import 'prismjs/components/prism-python.min';
import 'prismjs/components/prism-r.min';
import 'prismjs/components/prism-typescript.min';
